import request from 'axios';
import reverse from 'lodash/reverse';

/* ACTIONS
================================================================================================ */
const SEE_RESOURCE = 'crowdspring/admin/SEE_RESOURCE';
const SEE_RESOURCE_SUCCESS = 'crowdspring/admin/SEE_RESOURCE_SUCCESS';

/* HELPERS
================================================================================================ */
/* format stats in the way expected by the frontend */
export const formatStats = (payload) => {
  const current = payload[0];
  return Object.keys(current).reduce((acc, k) => {
    return {
      ...acc,
      [k]: {
        ...current[k],
        history: reverse(payload.slice(1).map(i => i[k].count))
      }
    };
  }, {});
}

/* INITIAL STATES
================================================================================================ */
const initialState = {
  resourceSeers: []
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEE_RESOURCE_SUCCESS:
      return {
        ...state,
        resourceSeers: action.payload
      };
    default:
      return state;
  }
}

export const seeResource = (name, id) => (dispatch) => {
  return dispatch({
    type: SEE_RESOURCE,
    promise: request.get(`/api/v1/${name}/${id}/seeing/`)
  });
};



// WEBPACK FOOTER //
// ./admin/ducks/common.js